/* Cachivachi theme scripts — no dependencies. */
(function () {
  'use strict';

  var C = window.Cachivachi || { routes: { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart', root: '/' }, cartType: 'page' };
  var DRAWER_SECTION = 'cart-drawer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Mobile menu ---------- */
  $$('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = $('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  });

  /* ---------- Quantity steppers (product + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && $('[data-qty-input]', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart count ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = C.routes.cart; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var close = $('[data-cart-close].icon-btn', d);
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function renderDrawer(sections) {
    if (!sections || !sections[DRAWER_SECTION]) return;
    var d = drawer();
    if (!d) return;
    var wasOpen = d.classList.contains('is-open');
    var tmp = document.createElement('div');
    tmp.innerHTML = sections[DRAWER_SECTION];
    var fresh = tmp.querySelector('#CartDrawer');
    if (!fresh) return;
    d.innerHTML = fresh.innerHTML;
    if (wasOpen) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
  }

  function showAdded(data) {
    var d = drawer();
    if (!d) return;
    var body = $('[data-cart-drawer-body]', d);
    if (!body) return;
    var item = data && data.items && data.items[0] ? data.items[0] : data;
    var name = item && (item.product_title || item.title) ? String(item.product_title || item.title).split(' | ')[0] : '';
    var note = document.createElement('div');
    note.className = 'drawer-added';
    note.setAttribute('role', 'status');
    var strong = document.createElement('strong');
    strong.textContent = 'Agregado a tu carrito';
    note.appendChild(strong);
    if (name) {
      var span = document.createElement('span');
      span.textContent = name;
      note.appendChild(span);
    }
    body.insertBefore(note, body.firstChild);
    body.scrollTop = 0;
  }

  function refreshCount() {
    return fetch(C.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function addToCart(items, button, errorEl) {
    if (button) button.classList.add('is-loading');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    var useDrawer = C.cartType === 'drawer' && drawer();
    var body = { items: items };
    if (useDrawer) body.sections = DRAWER_SECTION;
    return fetch(C.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'No se pudo agregar al carrito.');
        if (!useDrawer) { window.location.href = C.routes.cart; return; }
        renderDrawer(res.data.sections);
        refreshCount();
        showAdded(res.data);
        openDrawer();
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else { window.alert(err.message); }
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function changeLine(key, qty) {
    var d = drawer();
    if (d) d.style.cursor = 'progress';
    return fetch(C.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: DRAWER_SECTION })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderDrawer(data.sections);
        updateCount(data.item_count);
      })
      .finally(function () { if (d) d.style.cursor = ''; });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer() && C.cartType === 'drawer') { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var change = e.target.closest('[data-cart-change]');
    if (change) { changeLine(change.getAttribute('data-cart-change'), parseInt(change.getAttribute('data-qty'), 10)); return; }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) { addToCart([{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }], quick, null); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-input]');
    if (input) changeLine(input.getAttribute('data-cart-input'), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var defaultLabel = addLabel ? addLabel.textContent.trim() : 'Agregar al carrito';
    var errorEl = $('[data-form-error]', section);
    var gallery = $('[data-gallery]', section);

    /* Gallery */
    var slides = gallery ? $$('.gallery__slide', gallery) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === current);
        var v = s.querySelector('video');
        if (v) { if (n === current) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
      });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    function showMedia(id) {
      if (!id) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (idx > -1) show(idx);
    }
    if (gallery) {
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      var main = $('.gallery__main', gallery), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    }

    /* Variants */
    function selectedOptions() {
      var picker = $('[data-variant-picker]', section);
      if (!picker) return null;
      var opts = [];
      $$('input[type="radio"]:checked', picker).forEach(function (r) {
        opts[parseInt(r.getAttribute('data-option-index'), 10)] = r.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateAvailability(opts) {
      var picker = $('[data-variant-picker]', section);
      if (!picker) return;
      $$('input[type="radio"]', picker).forEach(function (r) {
        var idx = parseInt(r.getAttribute('data-option-index'), 10);
        var test = opts.slice();
        test[idx] = r.value;
        var v = findVariant(test);
        r.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function badgeHtml(v) {
      if (!v.available) return '<span class="badge badge--soldout">Agotado</span>';
      if (data.saleBadge && v.compare_at_price > v.price) {
        if (data.saleBadgeStyle === 'percent') {
          return '<span class="badge badge--sale">-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
        }
        return '<span class="badge badge--sale">Oferta</span>';
      }
      return '';
    }

    function applyVariant(v) {
      if (idInput) idInput.value = v ? v.id : '';
      var onSale = v && v.compare_at_price > v.price;
      $$('[data-price]', section).forEach(function (p) {
        var cur = $('[data-price-current]', p), cmp = $('[data-price-compare]', p);
        if (!v) return;
        if (cur) cur.textContent = v.price_formatted;
        if (cmp) { cmp.textContent = v.compare_formatted; cmp.hidden = !onSale; }
        p.classList.toggle('price--sale', !!onSale);
      });
      $$('[data-sale-badge]', section).forEach(function (b) { b.innerHTML = v ? badgeHtml(v) : ''; });
      $$('[data-savings]', section).forEach(function (s) {
        s.hidden = !onSale;
        var amt = $('[data-savings-amount]', s);
        if (amt && v) amt.textContent = v.savings_formatted;
      });
      var available = !!(v && v.available);
      [addBtn, $('[data-sticky-add]', section)].forEach(function (b) { if (b) b.disabled = !available; });
      if (addLabel) addLabel.textContent = !v ? 'No disponible' : (available ? defaultLabel : 'Agotado');
      if (v && v.media_id) showMedia(v.media_id);
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    var picker = $('[data-variant-picker]', section);
    if (picker) {
      picker.addEventListener('change', function (e) {
        var r = e.target;
        if (r.type !== 'radio') return;
        var label = $('[data-option-selected="' + r.getAttribute('data-option-index') + '"]', section);
        if (label) label.textContent = r.value;
        var opts = selectedOptions();
        updateAvailability(opts);
        applyVariant(findVariant(opts));
      });
      updateAvailability(selectedOptions());
    }

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var qtyInput = $('[data-qty-input]', form);
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        if (!idInput || !idInput.value) return;
        addToCart([{ id: parseInt(idInput.value, 10), quantity: qty }], addBtn, errorEl);
      });
    }

    /* Sticky add to cart */
    var sticky = $('[data-sticky-atc]', section);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          var visible = !entry.isIntersecting && below;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      });
      io.observe(addBtn);
      var stickyBtn = $('[data-sticky-add]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  });

  /* ---------- Reviews carousel: random order, autoplay, read more ---------- */
  $$('[data-reviews]').forEach(function (track) {
    var designMode = window.Shopify && window.Shopify.designMode;
    var section = track.closest('section') || document;
    var cards = $$('[data-review]', track);
    var visible = parseInt(track.getAttribute('data-visible'), 10) || cards.length;
    var collapseMs = (parseInt(track.getAttribute('data-collapse'), 10) || 12) * 1000;
    var autoplayMs = (parseInt(track.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (track.getAttribute('data-random') === 'true') {
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
      }
      cards.forEach(function (c) { track.appendChild(c); });
    }
    cards.forEach(function (c, n) { c.hidden = n >= visible; });
    var shown = cards.filter(function (c) { return !c.hidden; });
    function resetScroll() {
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = prevBehavior;
    }
    resetScroll();
    requestAnimationFrame(resetScroll);

    /* Read more */
    function collapse(card) {
      var btn = $('[data-review-more]', card);
      card.classList.remove('is-expanded');
      if (btn) { btn.textContent = 'Leer más'; btn.setAttribute('aria-expanded', 'false'); }
      clearTimeout(card._collapseTimer);
    }
    function setup(card) {
      var text = $('[data-review-text]', card);
      var btn = $('[data-review-more]', card);
      if (!text || !btn) return;
      btn.hidden = !(text.scrollHeight > text.clientHeight + 2);
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        if (card.classList.contains('is-expanded')) { collapse(card); return; }
        card.classList.add('is-expanded');
        btn.textContent = 'Leer menos';
        btn.setAttribute('aria-expanded', 'true');
        clearTimeout(card._collapseTimer);
        card._collapseTimer = setTimeout(function () { collapse(card); }, collapseMs);
      });
    }
    function measureAll() { shown.forEach(function (c) { if (!c.classList.contains('is-expanded')) setup(c); }); }
    measureAll();
    window.addEventListener('resize', function () { clearTimeout(track._rt); track._rt = setTimeout(measureAll, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);

    /* Navigation */
    function step() {
      var first = shown[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function go(dir) {
      if (dir > 0 && atEnd()) { track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
      if (dir < 0 && track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    var prev = $('[data-carousel-prev]', section), next = $('[data-carousel-next]', section);
    if (prev) prev.addEventListener('click', function () { go(-1); pause(8000); });
    if (next) next.addEventListener('click', function () { go(1); pause(8000); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); pause(8000); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); pause(8000); }
    });
    track.addEventListener('scroll', function () {
      shown.forEach(function (c) {
        if (!c.classList.contains('is-expanded')) return;
        var r = c.getBoundingClientRect(), tr = track.getBoundingClientRect();
        if (r.right < tr.left || r.left > tr.right) collapse(c);
      });
    }, { passive: true });

    /* Autoplay */
    var timer = null, inView = false, hovering = false, pausedUntil = 0;
    function tick() {
      if (!inView || hovering || Date.now() < pausedUntil || document.hidden) return;
      if (shown.some(function (c) { return c.classList.contains('is-expanded'); })) return;
      go(1);
    }
    function pause(ms) { pausedUntil = Date.now() + ms; }
    if (autoplayMs > 0 && shown.length > 1) {
      timer = setInterval(tick, autoplayMs);
      track.addEventListener('pointerenter', function () { hovering = true; });
      track.addEventListener('pointerleave', function () { hovering = false; });
      track.addEventListener('touchstart', function () { pause(10000); }, { passive: true });
      track.addEventListener('focusin', function () { hovering = true; });
      track.addEventListener('focusout', function () { hovering = false; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (!inView) shown.forEach(function (c) { if (c.classList.contains('is-expanded')) collapse(c); });
        });
      }, { threshold: 0.3 }).observe(track);
    } else { inView = true; }
  });

  /* ---------- Collection sorting ---------- */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Customer login: recover password toggle ---------- */
  function toggleRecover(showRecover) {
    var rec = document.getElementById('RecoverPassword'), log = document.getElementById('CustomerLogin');
    if (!rec || !log) return;
    rec.hidden = !showRecover;
    log.hidden = showRecover;
  }
  $$('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      toggleRecover(a.getAttribute('href') === '#recover');
    });
  });
  if (window.location.hash === '#recover') toggleRecover(true);

  /* ---------- Generic product carousel (oils): random order + arrows ---------- */
  $$('[data-carousel]').forEach(function (track) {
    var designMode = window.Shopify && window.Shopify.designMode;
    var section = track.closest('section') || document;
    var items = $$('[data-carousel-item]', track);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (track.getAttribute('data-random') === 'true') {
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = items[i]; items[i] = items[j]; items[j] = t;
      }
      items.forEach(function (c) { track.appendChild(c); });
    }
    function resetScroll() {
      var b = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = b;
    }
    resetScroll();
    requestAnimationFrame(resetScroll);
    var prev = $('[data-carousel-prev]', section), next = $('[data-carousel-next]', section);
    function overflowing() { return track.scrollWidth > track.clientWidth + 4; }
    function updateNav() {
      var show = overflowing();
      [prev, next].forEach(function (b) { if (b) b.parentNode.style.visibility = show ? '' : 'hidden'; });
    }
    function step() {
      var first = items[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var behavior = reduceMotion ? 'auto' : 'smooth';
      if (dir > 0 && end) { track.scrollTo({ left: 0, behavior: behavior }); return; }
      if (dir < 0 && track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: behavior }); return; }
      track.scrollBy({ left: dir * step(), behavior: behavior });
    }
    var autoplayMs = (parseInt(track.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var inView = false, hovering = false, pausedUntil = 0;
    function pause(ms) { pausedUntil = Date.now() + ms; }
    if (prev) prev.addEventListener('click', function () { go(-1); pause(8000); });
    if (next) next.addEventListener('click', function () { go(1); pause(8000); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); pause(8000); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); pause(8000); }
    });
    if (autoplayMs > 0 && items.length > 1) {
      setInterval(function () {
        if (!inView || hovering || Date.now() < pausedUntil || document.hidden || !overflowing()) return;
        go(1);
      }, autoplayMs);
      track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
      track.addEventListener('pointerleave', function () { hovering = false; });
      track.addEventListener('touchstart', function () { pause(8000); }, { passive: true });
      track.addEventListener('focusin', function () { hovering = true; });
      track.addEventListener('focusout', function () { hovering = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { inView = e.isIntersecting; });
        }, { threshold: 0.3 }).observe(track);
      } else { inView = true; }
    }
    updateNav();
    window.addEventListener('resize', function () { clearTimeout(track._nt); track._nt = setTimeout(updateNav, 150); });
  });
})();
